import React from 'react'
import './style.scss'

export const Lightbox = props => (
  <div className={`lightbox + ${props.on && 'on'}`}>
    <div className="lightbox__content">{props.children}</div>
  </div>
)

export const MobileLightbox = props => (
  <div className={`mobile-lightbox + ${props.on && 'on'}`}>
    <div className="mobile-lightbox__content">{props.children}</div>
  </div>
)


